// Raffle opinion form translations in English
const sorteoForm = {
    title: "📋 Participation Form",
    duplicateError: "You have already rated {{chapter}}. Try another one!",

    // Fields
    emailLabel: "📧 UEMC University Email *",
    emailPlaceholder: "your.name@alumnos.uemc.es",
    emailHelp: "Only @alumnos.uemc.es",
    emailRequired: "Required",
    emailInvalid: "Only @alumnos.uemc.es emails are allowed",

    chapterLabel: "📖 Which chapter did you read? *",
    chapterError: "Select a chapter",
    chapter: "Chapter",

    genderLabel: "What is your gender?",
    genderMale: "Male",
    genderFemale: "Female",
    genderOther: "Other",

    ageLabel: "What is your age?",
    ageError: "Valid age required",

    postalCodeLabel: "What is your postal code?",
    postalCodeError: "5-digit postal code",

    formatLabel: "How did you read the comic?",
    formatDigital: "Digital",
    formatPrinted: "Printed",

    readerLabel: "Do you consider yourself a regular comic reader?",
    readerDescription: "1 = Not at all, 5 = Very much",

    visitedLabel: "Have you visited the place in the chapter?",
    yes: "Yes",
    no: "No",

    knewPlaceLabel: "Did you know the place before reading the comic?",

    visitInterestLabel: "How interested are you in visiting the place?",
    visitInterestDescription: "1 = None, 5 = Very much",

    emotionsLegend: "Emotions while reading the comic",
    curiosityLabel: "Curiosity (1 = None, 5 = A lot)",
    prideLabel: "Pride in heritage (1 = None, 5 = A lot)",
    connectionLabel: "Connection with the monument (1 = None, 5 = A lot)",

    readingTimeLabel: "How do you rate the reading time?",
    short: "Short",
    adequate: "Adequate",
    long: "Long",

    flashbacksLabel: "Did you understand the flashbacks in the chapter?",

    preferredFormatLabel: "What format do you prefer for reading comics?",
    both: "Both",
    noAnswer: "N/A",

    adventuresLabel: "Are you interested in Zaquiel's adventures?",
    adventuresDescription: "1 = Not at all, 5 = Very much",

    narrativeLabel: "Did you like how the monument is narrated?",
    narrativeDescription: "1 = Not at all, 5 = Very much",

    commentsLabel: "Additional comments",

    gdprLabel: "I have read and accept the Raffle Privacy Policy",
    gdprError: "You must accept the privacy policy",

    required: "Required field",
    submitButton: "Participate",
    submitting: "Sending...",
    backButton: "Back",
    submitError: "Submission error. Please try again."
};

export default sorteoForm;
